export default __webpack_public_path__ + "static/media/FALKSALT SAILOR cyprus.e69704a2.png";